const _ = require('lodash');
// var dateFormat = require("date-fns/format");
const moment = require('moment/moment');
import { debounce } from 'ts-debounce';
import { GetConsentsService } from '../consents-services/get-consents.service';
import { ConsentsStatusService } from '../consents-services/consents-status.service';
import { DataService } from './data.service';
import { UtilityService } from '../utility.service';
import { PrivacySettings } from './embedding/privacysettings';
import { Consent } from '../../dataTypes/type-consent';

const checkboxTemplate1 = require('../../../components/atoms/input/checkbox/checkbox.hbs');
const paragraphView = require('../../../components/atoms/text/paragraph/paragraph.hbs');
const headingView = require('../../../components/atoms/text/heading/heading.hbs');
const linkView = require('../../../components/atoms/text/link/link.hbs');

const catOverview = require('../../../components/templates/embed-view/cat-overview/cat-overview.hbs');
/**
 * This class handles embedding in custom tags inside our script.
 */
export class CustomEmbedService {
    private utilityService: UtilityService;
    private privacySettings: PrivacySettings = null;
    constructor(utilityService) {
        this.utilityService = utilityService;
    }

    static injectCurrentDate() {
        // var tags = document.getElementsByTagName("uc-date");
        const tags = document.getElementsByClassName('uc-custom-date');
        _.forEach(tags, (tag: any) => {
            const format = tag.getAttribute('displayformat');
            const date = moment().format(format); // dateFormat(new Date(), format); //
            tag.innerHTML = date;
        });
    }

    injectTemplateOnHost(embeddingId?: string) {
        if (!this.utilityService.settingsService.elementsVisibility.isEmbeddedVisible) {
            return;
        }

        const tags = document.getElementsByClassName('uc-embed');
        const cssEmbeddedPrefix = 'uc_embed_';
        let currentPrefixCounter = 0;

        Array.prototype.forEach.call(tags, (tag: HTMLElement) => {

            // Increment the counter to separate each embedding
            currentPrefixCounter++;

            // If only a specific embedding is requested skip others
            if (embeddingId && tag.id !== embeddingId) {
                return;
            }

            const idPrefix = `${cssEmbeddedPrefix}${currentPrefixCounter}_`;

            // if this embedding has no id yet, initialize it
            if (!tag.id) {
                tag.id = idPrefix;
            }

            const layout = tag.getAttribute('uc-layout');
            const attribute = tag.getAttribute('uc-data');
            const data = (attribute) ? attribute
                .split(',')
                .map(function (e) {
                    return e.replace(/ /g, '');
                }) : [];

            // Determine which layout shall be embedded
            switch (layout) {

            // Layout that shows similar design as privacy settings side
            case 'privacySettings':
                this.renderPrivacySetting(tag, idPrefix);
                break;

            case 'privacyToggles':
            case '2':
                this.renderPrivacyToggle(tag, data);
                break;
            case '1':
            case 'serviceDetails':
            default:
                this.renderServiceDetails(tag, data);
                break;
            }
        });
    }

    private renderPrivacySetting(tag: HTMLElement, idPrefix: string) {
        // Initialize controller if necessary
        if (this.privacySettings === null) {
            // We pass the render function with this bound
            this.privacySettings = new PrivacySettings(this.injectTemplateOnHost.bind(this));
        }

        // Render this embedding
        this.privacySettings.embed(tag, idPrefix, this.utilityService);
    }

    private renderPrivacyToggle(tag: HTMLElement, data: string[]) {
        const categorySlug = tag.getAttribute('uc-category-slug');
        let outputData = '<div class="usercentrics-button">';
        const selectAll = tag.getAttribute('uc-isSelectAll');

        if (selectAll) {
            outputData += this.getEmbedDataForSelectAllLayout2(data);
            outputData += '</div>';
            tag.innerHTML = outputData;

            if (data.indexOf('toggle') !== -1) {
                this.addSelectAllChangeListener(tag);
            }
        } else {
            const category = GetConsentsService.getAppropriateCategory(DataService.categories, categorySlug);

            if (category) {
                outputData += this.getEmbedDataForCategoryLayout2(data, category);
            } else {
                outputData += this.getEmbedDataForCategoryLayout2(data);
            }

            outputData += '</div>';
            tag.innerHTML = outputData;
            if (data.indexOf('toggle') !== -1) {
                this.addCategoryChangeListener(tag, category);
            }
        }
    }

    private renderServiceDetails(tag: HTMLElement, data: string[]) {
        const consentName = tag.getAttribute('uc-consent-name');
        const consent = GetConsentsService.getConsentByProcessor(consentName);
        let outputData = '<div class="usercentrics-button">';

        if (consent) {
            outputData += this.getEmbedDataForConsentLayout1(data, consent);
        } else {
            outputData += this.getEmbedDataForConsentLayout1(data);
        }

        outputData += '</div>';
        tag.innerHTML = outputData;
        if (data.indexOf('optInCheckboxWithLabel') !== -1 || data.indexOf('all') !== -1) {
            this.addConsentChangeListener(tag, consent);
        }
    }

    static getDescription(consent: Consent.Consent, consentTemplate: Consent.ConsentTemplate) {
        if (consent.description && consent.description.length) {
            return consent.description.replace(/(\r\n|\n|\r)/gm, '<br>');
        }
        if (consentTemplate) {
            if (typeof consentTemplate.descriptionOfService !== 'undefined'
                && consentTemplate.descriptionOfService) {
                return consentTemplate.descriptionOfService.replace(/(\r\n|\n|\r)/gm, '<br>');
            } else if (typeof consentTemplate.description !== 'undefined'
                && consentTemplate.description) {
                return consentTemplate.description.replace(/(\r\n|\n|\r)/gm, '<br>');
            }
        }
        return '';
    }

    getEmbedDataForSelectAllLayout2(data) {
        let outputData = '';
        const optinConsent = GetConsentsService.getOptinConsent();
        const viewData = {
            headingText:
                data.indexOf('categoryName') !== -1
                    ? this.utilityService.settingsService.settings.labels.btnSelectAll
                    : '',
            paragraph: data.indexOf('description') !== -1 && optinConsent ? CustomEmbedService.getDescription(optinConsent, null) : '',
            titleText: '',
            isCheckbox: data.indexOf('toggle') !== -1 ? true : false,
            isToggleLabelHidden: data.indexOf('toggleLabel') === -1 ? true : false,
            isIcon: data.indexOf('icon') !== -1 ? true : false,
            isIntermediate: ConsentsStatusService.selectAllStatus.isIntermediateState,
            isChecked: ConsentsStatusService.selectAllStatus.status,
            toggleLabelPosition: 'bottom',
            isToggleDisabled: false,
            toggleClass: 'uc-embed-toggle-selectAll',
            toggleInputClass: 'uc-toggle-selectAll-input',
            toggleLabelClass: 'uc-toggle-selectAll-label',
            toggleLabel: this.utilityService.settingsService.settings.labels.statusActive
        };
        viewData.toggleLabel =
            viewData.isIntermediate || viewData.isChecked
                ? this.utilityService.settingsService.settings.labels.statusActive
                : this.utilityService.settingsService.settings.labels.statusInactive;
        outputData += catOverview(viewData);
        return outputData;
    }

    getEmbedDataForCategoryLayout2(data, category?) {
        let output = '';
        if (!category) {
            const categories = DataService.categories;
            categories.forEach(element => {
                if (!element.isHidden) {
                    output += this.getEmbedDataForCategoryLayout2(data, element);
                }
            });
            return output;
        }
        const viewData = {
            headingText: data.indexOf('categoryName') !== -1 ? category.label : '',
            paragraph: data.indexOf('description') !== -1 ? category.description : '',
            titleText: '',
            isCheckbox: data.indexOf('toggle') !== -1 ? true : false,
            isToggleLabelHidden: data.indexOf('toggleLabel') === -1 ? true : false,
            isIcon: data.indexOf('icon') !== -1 ? true : false,
            isIntermediate: category.isIntermediateState,
            isChecked: category.status,
            toggleLabel:
                category.status || category.isIntermediateState
                    ? this.utilityService.settingsService.settings.labels.statusActive
                    : this.utilityService.settingsService.settings.labels.statusInactive,
            toggleLabelPosition: 'bottom',
            isToggleDisabled: category.isEssential,
            toggleClass: 'uc-toggle-category-' + category.categorySlug,
            toggleInputClass: 'uc-toggle-category-input-' + category.categorySlug,
            toggleLabelClass: 'uc-toggle-category-label-' + category.categorySlug
        };
        output += catOverview(viewData);
        return output;
    }

    getEmbedDataForConsentLayout1(data, consent?) {

        let output = '';
        let consents = [];
        if (!consent) {
            consents = DataService.consents;
        } else {
            consents.push(consent);
        }

        consents.forEach((consent) => {
            if (consent.isHidden) {
                output += '';
            } else {
                output += this.getEmbedHtmlForLayout2019(data, consent);
            }
        });
        return output;
    }

    getEmbedHtmlForLayout2019(data, consent?) {
        const labels = this.utilityService.settingsService.settings.labels;
        this.utilityService.developmentLog('embed layout1', data);
        let output = '';
        const generalOptin = "HJI5SmLm7";
        if (!consent) {
            const consents = DataService.consents;
            this.utilityService.developmentLog('all consents for embed', consents);
            consents.forEach(element => {
                output += this.getEmbedHtmlForLayout2019(data, element);
            });
            return output;
        }
        if (!DataService.consentTemplates[consent.templateId][consent.version]) {
            return;
        }
        const consentTemplate = DataService.consentTemplates[consent.templateId][consent.version];
        this.utilityService.developmentLog('embedding layout1 for ', consentTemplate.dataProcessors);
        this.utilityService.developmentLog('embedding layout1 for (Full consent)', consent);
        output += '<div class="uc-consent-info-content">';
        const fieldReplacement = {
            optOutUrl: 'furtherInformation',
            privacyPolicyUrl: 'furtherInformation',
            dataAttributes: 'dataCollected'
        };

        let furtherInformationAlreadyShown = false;
        data.forEach(element => {

            // Rewrite legacy fields if they are present
            if (typeof fieldReplacement[element] !== 'undefined') {
                element = fieldReplacement[element];
            }
            switch (element) {

                case 'all':
                    output += this.getOptInCheckboxWithLabel(consent);
                    output += '<div class="uc-consent-info-section">' + CustomEmbedService.getDescription(consent, consentTemplate) + '</div>';
                    if (consent.templateId !== generalOptin) {
                        output += CustomEmbedService.getProcessorDetails(consentTemplate);
                        output += this.getDataPurposes(consentTemplate, labels.dataPurposes);
                        output += this.getTechnologyUsed(consentTemplate, labels.technologiesUsed);
                        output += this.getDataCollected(consentTemplate, labels.dataCollectedList);
                        output += this.getLegalBasis(consentTemplate, labels.legalBasisList);
                        output += CustomEmbedService.getLocationOfProceesing(consentTemplate, labels.locationOfProcessing);
                        output += CustomEmbedService.getRetentionPeriod(consentTemplate, labels.retentionPeriod);
                        output += this.getDataRecipientsList(consentTemplate, labels.dataRecipientsList);
                        output += CustomEmbedService.getThirdCountryTransfer(consentTemplate.thirdCountryTransfer, labels.transferToThirdCountries);
                        output += CustomEmbedService.getDataProtectionOfficer(consentTemplate.dataProtectionOfficer, labels.dataProtectionOfficer);
                        output += CustomEmbedService.getLinks(consentTemplate, labels);
                    }
                    break;
                case 'optInCheckboxWithLabel':
                    output += this.getOptInCheckboxWithLabel(consent);
                    break;
                case 'processorNames':
                    output += CustomEmbedService.getProcessorDetails(consentTemplate);
                    break;
                case 'serviceNames':
                    output += CustomEmbedService.getProcessorName(consentTemplate);
                    break;
                case 'description':
                    output += `<div class="uc-consent-info-section">${CustomEmbedService.getDescription(consent, consentTemplate)}</div>`;
                    break;
                case 'dataPurposes':
                    if (consent.shortid !== generalOptin) {
                        output += this.getDataPurposes(consentTemplate, labels.dataPurposes);
                    }
                    break;
                case 'technologiesUsed':
                    if (consent.shortid !== generalOptin) {
                        output += this.getTechnologyUsed(consentTemplate, labels.technologiesUsed);
                    }
                    break;
                case 'dataCollected':
                    if (consent.shortid !== generalOptin) {
                        output += this.getDataCollected(consentTemplate, labels.dataCollectedList);
                    }
                    break;
                case 'legalBasis':
                    output += this.getLegalBasis(consentTemplate, labels.legalBasisList);
                    break;
                case 'locationOfProcessing':
                    if (consent.templateId !== generalOptin) {
                        output += CustomEmbedService.getLocationOfProceesing(consentTemplate, labels.locationOfProcessing);
                    }
                    break;
                case 'retentionPeriod':
                    output += CustomEmbedService.getRetentionPeriod(consentTemplate, labels.retentionPeriod);
                    break;
                case 'dataRecipients':
                    if (consent.shortid !== generalOptin) {
                        output += this.getDataRecipientsList(consentTemplate, labels.dataRecipientsList);
                    }
                    break;
                case 'thirdCountryTransfer':
                    if (consent.templateId !== generalOptin) {
                        output += CustomEmbedService.getThirdCountryTransfer(consentTemplate.thirdCountryTransfer, labels.transferToThirdCountries);
                    }
                    break;
                case 'dataProtectionOfficer':
                    if (consent.templateId !== generalOptin) {
                        output += CustomEmbedService.getDataProtectionOfficer(consentTemplate.dataProtectionOfficer, labels.dataProtectionOfficer);

                    }
                    break;
                case 'furtherInformation':
                    // Due to legacy fields this might be shown multiple times. Only show it once.
                    if (furtherInformationAlreadyShown) {
                        break;
                    }
                    furtherInformationAlreadyShown = true;
                    if (consent.templateId !== generalOptin) {
                        output += CustomEmbedService.getLinks(consentTemplate, labels);
                    }
                    break;
                case 'controllerNames':
                    output += headingView({
                        headingLevel: 1,
                        text: consent.dataControllers,
                    });
                    break;
                default:
                    break;
            }
        });
        output += '</div>'; // end .uc-consent-info-content
        return output;
    }

    getOptInCheckboxWithLabel(consent) {
        const isEssential = GetConsentsService.isConsentEssential(consent);
        return checkboxTemplate1({
            shortid: consent.templateId,
            isChecked: isEssential || consent.consentStatus,
            isDisabled: isEssential || (!this.utilityService.isConsentChangeAllow),
            isIntermediate: false,
            consentTemplates: DataService.consentTemplates,
            version: consent.version,
            labelPosition: 'right',
            customContainerClass: 'uc-consent-title',
            customLabelClass: 'uc-heading4',
        });
    }

    static getProcessorName(consentTemplate) {
        return `<div class="uc-consent-info-section">
                <div class="heading headinglevel-1">${consentTemplate.dataProcessors}</div>
            </div>`;
    }

    static getProcessorDetails(consentTemplate: Consent.ConsentTemplate) {
        return `<div class="uc-consent-info-section">
                <p>${consentTemplate.nameOfProcessingCompany ? consentTemplate.nameOfProcessingCompany : ''}</p>
                <p>${consentTemplate.addressOfProcessingCompany ? consentTemplate.addressOfProcessingCompany : ''}</p>
            </div>`;
    }

    getDataPurposes(consentTemplate, label) {
        if (this.checkForValidValues(consentTemplate.dataPurposesList)) {
            return `<div class="uc-consent-info-section">
            <h5 class="uc-consent-label-dataPurposes uc-mb-10">${label}</h5>
            ${consentTemplate.dataPurposesDescription ? `<div class="uc-consent-description"><p>${consentTemplate.dataPurposesDescription}</p></div>` : ''}
            ${this.getListHtml(consentTemplate.dataPurposesList)}
            </div>`;
        }
        return '';
    }

    getTechnologyUsed(consentTemplate, label) {
        if (consentTemplate.technologyUsed && Array.isArray(consentTemplate.technologyUsed)) {
            consentTemplate.technologyUsed = consentTemplate.technologyUsed.filter(item => item !== null);
        }
        if (this.checkForValidValues(consentTemplate.technologyUsed)) {
            return `<div class="uc-consent-info-section">
                <h5 class="uc-consent-label-dataPurposes uc-mb-10">${label}</h5>
                ${consentTemplate.technologyUsedDescription ? `<div class="uc-consent-description"><p>${consentTemplate.technologyUsedDescription}</p></div>` : ''}
                ${this.getListHtml(consentTemplate.technologyUsed)}
            </div>`;
        }
        return '';
    }

    getDataCollected(consentTemplate, label) {
        if (this.checkForValidValues(consentTemplate.dataCollectedList)) {
            return `<div class="uc-consent-info-section">
                    <h5 class="uc-consent-label-dataPurposes uc-mb-10">${label}</h5>
                    ${consentTemplate.dataCollectedDescription ? `<div class="uc-consent-description"><p>${consentTemplate.dataCollectedDescription}</p></div>` : ''}
                    ${this.getListHtml(consentTemplate.dataCollectedList)}
                </div>`;
        }
        return '';
    }

    getLegalBasis(consentTemplate, label) {
        if (this.checkForValidValues(consentTemplate.legalBasisList)) {
            return `<div class="uc-consent-info-section">
                <h5 class="uc-consent-label-dataPurposes uc-mb-10">${label}</h5>
                ${consentTemplate.legalBasisDescription ? `<div class="uc-consent-description"><p>${consentTemplate.legalBasisDescription}</p></div>` : ''}
                ${this.getListHtml(consentTemplate.legalBasisList)}
            </div>`;
        } else if (consentTemplate.legalGround) {
            return `<div class="uc-consent-info-section">
                <h5 class="uc-consent-label-technologiesUsed uc-mb-10">
                    ${label}
                </h5>
                ${consentTemplate.legalGround}
            </div>`;
        }
        return '';
    }

    static getLocationOfProceesing(consentTemplate, label) {
        if (consentTemplate.locationOfProcessing) {
            return `<div class="uc-consent-info-section">
            <h5 class="uc-consent-label-dataPurposes uc-mb-10">${label}</h5>
            <div class="uc-consent-description"><p>${consentTemplate.locationOfProcessing}</p></div>
            </div>`;
        }
        return '';
    }

    static getRetentionPeriod(consentTemplate, label) {
        if ((consentTemplate.retentionPeriodList && consentTemplate.retentionPeriodList.length) || consentTemplate.retentionPeriodDescription) {
            return `<div class="uc-consent-info-section">
                <h5 class="uc-consent-label-dataPurposes uc-mb-10">${label}</h5>
                ${consentTemplate.retentionPeriodDescription ? `<div class="uc-consent-description"><p>${consentTemplate.retentionPeriodDescription}</p></div>` : ''}
            </div>`;
        }
        return '';
    }

    getDataRecipientsList(consentTemplate, label) {
        if (this.checkForValidValues(consentTemplate.dataRecipientsList)) {
            return `<div class="uc-consent-info-section">
                <h5 class="uc-consent-label-dataPurposes uc-mb-10">${label}</h5>
                ${consentTemplate.dataRecipientsDescription ? `<div class="uc-consent-description"><p>${consentTemplate.dataRecipientsDescription}</p></div>` : ''}
                ${this.getListHtml(consentTemplate.dataRecipientsList)}
                </div>`;
        }
        return '';
    }

    static getThirdCountryTransfer(thirdCountryTransfer, label) {
        if (thirdCountryTransfer) {
            return `<div class="uc-consent-info-section">
            <h5 class="uc-consent-label-dataPurposes uc-mb-10">${label}</h5>
            <div class="uc-consent-description"><p>${thirdCountryTransfer}</p></div>
            </div>`;
        }
        return '';
    }

    static getDataProtectionOfficer(dataProtectionOfficer, label) {
        if (dataProtectionOfficer) {
            return `<div class="uc-consent-info-section">
            <h5 class="uc-consent-label-dataPurposes uc-mb-10">${label}</h5>
            <div class="uc-consent-description"><p><a href="mailto:${dataProtectionOfficer}">${dataProtectionOfficer}</a></p></div>
            </div>`;
        }
        return '';
    }

    static getLinks(consentTemplate, labels) {
        let output = '';
        if (consentTemplate.optOutDescription || consentTemplate.optOutUrl || consentTemplate.privacyPolicyURL || consentTemplate.cookiePolicyURL || consentTemplate.linkToDpa) {
            output += '<div class="uc-consent-info-section">';
            output += '<h5 class="uc-consent-label-dataPurposes uc-mb-10">' + labels.furtherInformationOptOut + '</h5>';
            if (consentTemplate.optOutDescription) {
                output += '<div class="uc-consent-description"><p>' + consentTemplate.optOutDescription + '</p></div>';
            }
            if (consentTemplate.optOutUrl) {
                output += '<div class="uc-consent-description"><p>' + labels.infomodal_optOutLink + ': <a href="'
                    + consentTemplate.optOutUrl + '" target0"_blank" rel="nofollow">' + consentTemplate.optOutUrl + '</a></p></div>';
            }
            if (consentTemplate.privacyPolicyURL) {
                output += '<div class="uc-consent-description"><p>' + labels.policyOf + ' <a href="'
                    + consentTemplate.privacyPolicyURL + '" target="_blank" rel="nofollow">' + consentTemplate.privacyPolicyURL + '</a></p></div>';
            }
            if (consentTemplate.cookiePolicyURL) {
                output += '<div class="uc-consent-description"><p>' + labels.infomodal_cookiePolicyOfProcessor + ': <a href="'
                    + consentTemplate.cookiePolicyURL + '" target="_blank" rel="nofollow">' + consentTemplate.cookiePolicyURL + '</a></p></div>';
            }
            if (consentTemplate.linkToDpa) {
                output += '<div class="uc-consent-description"><p>' + labels.infomodal_dpaUrl + ': <a href="'
                    + consentTemplate.linkToDpa + '" target="_blank" rel="nofollow">' + consentTemplate.linkToDpa + '</a></p></div>';
            }
            output += '</div>';
        }
        return output;
    }



    addSelectAllChangeListener(tag, category?) {
        const toggleCategoryElements = tag.getElementsByClassName('uc-embed-toggle-selectAll');

        const toggleCategoryInputElements = tag.getElementsByClassName('uc-toggle-selectAll-input');

        const toggleCategoryLabelElements = tag.getElementsByClassName('uc-toggle-selectAll-label');

        _.forEach(toggleCategoryElements, (toggleElm, index) => {
            if (toggleElm) {
                toggleElm.onclick = (event: any) => {
                    // event.preventDefault();
                    event.stopPropagation();
                    _.forEach(toggleCategoryInputElements, (toggleInElm, index) => {
                        toggleInElm.checked = !toggleInElm.checked;
                        toggleInElm.classList.remove('intermediate');
                    });
                    _.forEach(toggleCategoryLabelElements, (toggleLabelElm, index) => {
                        toggleLabelElm.innerHTML = toggleCategoryInputElements[index].checked
                            ? this.utilityService.settingsService.settings.labels.statusActive
                            : this.utilityService.settingsService.settings.labels.statusInactive;
                    });
                    this.changeSelectAllStatus(toggleCategoryInputElements[index].checked);
                };
            }
        });
    }

    addCategoryChangeListener(tag, category?: Consent.Category) {
        if (!category) {
            const categories = DataService.categories;
            categories.forEach(element => {
                this.addCategoryChangeListener(tag, element);
            });
            return;
        }
        if (category.isEssential || category.isHidden) {
            return;
        }

        const toggleCategoryElements = tag.getElementsByClassName('uc-toggle-category-' + category.categorySlug);

        const toggleCategoryInputElements = tag.getElementsByClassName(
            'uc-toggle-category-input-' + category.categorySlug
        );

        const toggleCategoryLabelElements = tag.getElementsByClassName(
            'uc-toggle-category-label-' + category.categorySlug
        );

        _.forEach(toggleCategoryElements, (toggleElm, index) => {
            if (toggleElm) {
                toggleElm.onclick = (event: any) => {
                    // event.preventDefault();
                    event.stopPropagation();
                    _.forEach(toggleCategoryInputElements, (toggleInElm, index) => {
                        toggleInElm.checked = !toggleInElm.checked;
                        toggleInElm.classList.remove('intermediate');
                    });
                    _.forEach(toggleCategoryLabelElements, (toggleLabelElm, index) => {
                        toggleLabelElm.innerHTML = toggleCategoryInputElements[index].checked
                            ? this.utilityService.settingsService.settings.labels.statusActive
                            : this.utilityService.settingsService.settings.labels.statusInactive;
                    });
                    this.changeCategoryStatus(category, toggleCategoryInputElements[index].checked);
                };
            }
        });
    }

    changeSelectAllStatus = debounce(function (checkStat) {
        DataService.consents.forEach(consent => {
            ConsentsStatusService.setUnsavedConsentStatus(consent, checkStat);
        });
        const cdcsDataPulledFromIframe = false;
        const action = 'onToggleSelectAll';
        const updatedBy = 'explicit';
        this.utilityService.saveConsentsService.saveConsents(action, updatedBy);
        this.utilityService.settingsService.saveFirstUserInteraction();
        this.utilityService.settingsService.bannerIsVisible = false;
        this.utilityService.UserCentricViewController.updateView();
    }, 500);

    changeCategoryStatus = debounce(function (category, checkStat) {
        ConsentsStatusService.changeCategorySelectedStatus(category, checkStat);
        const cdcsDataPulledFromIframe = false;
        const action = 'onToggleCategory';
        const updatedBy = 'explicit';
        this.utilityService.saveConsentsService.saveConsents(action, updatedBy);
        this.utilityService.settingsService.saveFirstUserInteraction();
        this.utilityService.settingsService.bannerIsVisible = false;
        this.utilityService.UserCentricViewController.updateView();
    }, 500);

    addConsentChangeListener(tag, consent?) {
        if (!consent) {
            const consents = DataService.consents;
            consents.forEach(element => {
                this.addConsentChangeListener(tag, element);
            });
            return;
        }
        const toggleConsentElement: HTMLElement = tag.querySelector('#toggle-consent-' + consent.templateId);
        if (toggleConsentElement) {
            toggleConsentElement.onclick = debounce((event: any) => {
                event.stopPropagation();
                const checkElem = toggleConsentElement.querySelector('input');
                this.updateSelectedStatusForConsent(consent, !checkElem.checked);
            });
        }
    }

    private updateSelectedStatusForConsent = debounce(function (consent, state) {
        ConsentsStatusService.setUnsavedConsentStatus(consent, state);
        const cdcsDataPulledFromIframe = false;
        const action = 'onToggleConsent';
        const updatedBy = 'explicit';
        this.utilityService.saveConsentsService.saveConsents(action, updatedBy);
        this.utilityService.settingsService.saveFirstUserInteraction();
        this.utilityService.settingsService.bannerIsVisible = false;
        this.utilityService.UserCentricViewController.updateView();
    }, 500);

    /**
     * 
     * @param value 
     */
    private getListHtml(value: string[] | string) {
        if (!Array.isArray(value)) {
            value = [value];
        }
        if (value.length === 0) {
            return '';
        }
        const cssClass = (value.length > 3) ? 'uc-flex-container uc-flex-2' : '';
        let output = `<ul class="${cssClass}">`;
        value.forEach(function (item) {
            output += `<li class="uc-flex-item ls-dash">${item}</li>`;
        });
        output += '</ul>';
        return output || '';
    }

    /**
     * Returns true if the value is an array with at least one entry
     * @param value 
     */
    private checkForValidValues(value: any) {
        if (!value || value === '') {
            return false;
        }
        if (Array.isArray(value) && value.length === 0) {
            return false;
        }
        return true;
    }
}
